module.exports = __webpack_public_path__ + "static/media/Quarry.6b1f60b4.wav";